import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: var(--bg-color);
    color: var(--primary-color);
`;

const AdminRoute = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        checkAdminRole();
    }, [location.pathname]);

    const checkAdminRole = async () => {
        try {
            const response = await fetch(getApiUrl(API_ENDPOINTS.CHECK_AUTH), {
                credentials: 'include'
            });
            
            if (!response.ok) {
                throw new Error('Auth check failed: ' + response.status);
            }
            
            const data = await response.json();
            
            if (data.success && data.user) {
                // ROLE KONTROLÜ - admin veya moderator
                if (data.user.role && (data.user.role === 'admin' || data.user.role === 'moderator')) {
                    setIsAdmin(true);
                } else {
                    setIsAdmin(false);
                    navigate('/');
                }
            } else {
                setIsAdmin(false);
                navigate('/');
            }
        } catch (error) {
            setIsAdmin(false);
            navigate('/');
        }
    };

    if (isAdmin === null) {
        return (
            <LoadingContainer>
                <div>Yetki kontrol ediliyor...</div>
            </LoadingContainer>
        );
    }

    if (!isAdmin) {
        return null;
    }

    return children;
};

export default AdminRoute;
